/**
 * Created by jonas on 2022-10-14.
 */
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {BS2} from "../BS2";
import {BS2Symbol, BS2SymbolStates} from "../reels/BS2Symbol";
import {gsap} from "gsap";

import {BS2Sound} from "../config/sound/BS2Sound";
import {ScatterSymbol} from "../reels/ScatterSymbol";
import {SimpleSpinReelModel, SymbolStopCallBackData} from "../../core/reel/simplereel/SimpleSpinReelModel";
import {BS2Statics} from "../config/BS2Statics";
import {WildSymbol} from "../reels/WildSymbol";
import {StateMatrixCoordinate} from "./StateMatrix";
import * as tls from "tls";

export class ReelUtils {

    public static scatters: SimpleReelModelSymbolData[] = [];

    constructor() {
    }

    private static playLandingSound(symbolData: SimpleReelModelSymbolData, data: SymbolStopCallBackData, isSingleSymbolDrop: boolean,isFirstWild:boolean=false): void {
        if (data.isNearWin) {
            BS2.soundPlayer.playSymCollapseSound(symbolData.reelId);
            BS2.soundPlayer.playSound(BS2Sound.SYM_LAND_NEAR_WIN.next());
        } else {
            if (isSingleSymbolDrop) {
                BS2.soundPlayer.playSymCollapseSound(symbolData.reelId);
            }
        }

        if (symbolData.name == BS2Statics.SYMBOLS.S) {
            BS2.soundPlayer.playScatterLandingSound(symbolData.reelId);
        } else if (symbolData.name == BS2Statics.SYMBOLS.W && !BS2.reelView.stickySymbols.matrix[symbolData.reelId][symbolData.reelPosition] && isFirstWild){
            BS2.soundPlayer.playWildLandingSound(symbolData.reelId);
        }
    }

    private static symbolStop(symbolData: SimpleReelModelSymbolData, data: SymbolStopCallBackData, isSingleSymbolDrop: boolean): gsap.core.Timeline {
        const stopTl: gsap.core.Timeline = gsap.timeline();

        let bounceLanding: boolean = data.isNearWin;
        if(!(BS2.apiPlugin.betFeatureController.getActiveBetFeature()?.name===BS2Statics.BOOSTED_BET_1 && symbolData.name==="W")){
            stopTl.add(() => {
                ReelUtils.playLandingSound(symbolData, data, isSingleSymbolDrop)
            });
        }


        const symbol: BS2Symbol = <BS2Symbol>symbolData.positionable;
        stopTl.add(symbol.getStateAnimation(BS2SymbolStates.LANDING));
        if (bounceLanding) {
            stopTl.add(BS2.reelView.getBounceShake(), 0);
        }


        return stopTl;

    }

    public static symbolStopDropIn(symbolData: SimpleReelModelSymbolData, data: SymbolStopCallBackData): gsap.core.Timeline {
        return ReelUtils.symbolStop(symbolData, data, data.isSingleSymbolDrop);
    }

    public static symbolStopFillUp(symbolData: SimpleReelModelSymbolData, data: SymbolStopCallBackData): gsap.core.Timeline {
        return ReelUtils.symbolStop(symbolData, data, data.isSingleSymbolDrop);
    }

    public static getScatterAttention(symbolData: SimpleReelModelSymbolData) {
        const tl = gsap.timeline();

        if (!BS2.model.isNearWinAllowed()) {
            return tl;
        }

        let stopSound = BS2Sound.SCATTER_LANDING_S1[ReelUtils.scatters.length];
        if (symbolData.name == "S2") {
            stopSound = BS2Sound.SCATTER_LANDING_S2[ReelUtils.scatters.length];
        }


        tl.add(() => {
            BS2.soundPlayer.playSound(stopSound)
        });
        ReelUtils.scatters.push(symbolData);
        if (ReelUtils.scatters.length == 1) {
            // stopTl.add((<ScatterSymbol>symbol).getIdleAnimation(), landEndTime);
        } else if (ReelUtils.scatters.length == 2) {

            for (let scatterData of ReelUtils.scatters) {
                const scatterSymbol = <ScatterSymbol>scatterData.positionable;
                tl.add(scatterSymbol.getStateAnimation(BS2SymbolStates.ATTENTION), 0.4);
            }
        } else if (ReelUtils.scatters.length == 3) {
            for (let scatterData of ReelUtils.scatters) {
                const scatterSymbol = <ScatterSymbol>scatterData.positionable;
                tl.add(scatterSymbol.getStateAnimation(BS2SymbolStates.WIN_HIGHLIGHT), 0.4);
            }
            BS2.model.hasWonFsClient = true;
        }

        return tl;
    }

    static reelBounce(id: number, allVisibleSymbols: SimpleReelModelSymbolData[]) {
        const tl:gsap.core.Timeline = gsap.timeline();
        BS2.soundPlayer.playReelStopSound(id);
        var isFirstDagger:boolean = true;
        var isFirstGuillotine:boolean = true;
        var isFirstWild:boolean =true;
        for (let symbolData of allVisibleSymbols) {
            if(symbolData.name == BS2Statics.SYMBOLS.D && isFirstDagger) {
                tl.add(()=>{BS2.soundPlayer.playSound(BS2Sound.D_LAND)});
                isFirstDagger = false;
            }
            if(symbolData.name == BS2Statics.SYMBOLS.G && isFirstGuillotine){
                tl.add(()=>{BS2.soundPlayer.playSound(BS2Sound.G_LAND)});
                isFirstGuillotine = false;
            }
            if(symbolData.name===BS2Statics.SYMBOLS.W && isFirstWild){
                ReelUtils.playLandingSound(symbolData, {isNearWin: false, isSingleSymbolDrop: false}, false,true);
                isFirstWild = false;
            }
            else{
                ReelUtils.playLandingSound(symbolData, {isNearWin: false, isSingleSymbolDrop: false}, false);
            }

        }
        ReelUtils.highlightWinLine(id);
    }


    public static findCurrentVisibleSqueezeSymbolPerReel() {
        const result = [-1, -1, -1, -1, -1];
        for (let i: number = 0; i < BS2.model.visibleReelMatrix.matrix.length; i++) {
            for (let j: number = 0; j < BS2.model.visibleReelMatrix.matrix[i].length; j++) {
                if (BS2.model.visibleReelMatrix.matrix[i][j] == "S" || BS2.model.visibleReelMatrix.matrix[i][j] == "S1") {
                    result[i] = j;

                }
            }
        }

        return result;
    }

    public static highlightWinLine(reel: number, firstWinHighlightReel: number = BS2Statics.firstWinHighlightReel) {
        for (let possibleLine of BS2.model.possibleWinData.lines) {
            if (reel >= firstWinHighlightReel && possibleLine.reels[reel]) {
                const currentScatterPositions: number[] = ReelUtils.findCurrentVisibleSqueezeSymbolPerReel();

                const potentialWins: StateMatrixCoordinate[] = possibleLine.matrix.getAllCoordinatesForValue(true);
                if (potentialWins.length > 0) {
                    let sound: string = BS2Sound.POTENTIAL_WIN[reel];
                    BS2.soundPlayer.playSoundWithPan(sound, reel);
                    for (let potWin of potentialWins) {
                        if (potWin.column > reel) {
                            break;
                        }
                        //The reel will shift positions after bounce one step down for all symbols above the scatter pos.
                        //Main game
                        if (BS2.model.isSuperFreespin()) {
                            if (potWin.row <= currentScatterPositions[potWin.column]) {
                                potWin.row -= 1;
                            }
                        } else {
                            if (potWin.row <= currentScatterPositions[potWin.column] && potWin.column == reel) {
                                potWin.row -= 1;
                            }

                        }
                        const symbolData: SimpleReelModelSymbolData = BS2.reelView.getVisibleSymbolDataAt(potWin.column, potWin.row);
                        let symbol: BS2Symbol = <BS2Symbol>symbolData.positionable;
                        if (BS2.reelView.stickySymbols.matrix[symbolData.reelId][symbolData.reelPosition]) {
                            (<BS2Symbol>BS2.reelView.stickySymbols.matrix[symbolData.reelId][symbolData.reelPosition]?.positionable).playPotentialWinAttention();
                        } else {
                            symbol.playPotentialWinAttention();
                        }
                    }
                }
            }
        }
    }


}